/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLicense = createReactComponent("outline", "license", "IconLicense", [["path", { "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11", "key": "svg-0" }], ["path", { "d": "M9 7l4 0", "key": "svg-1" }], ["path", { "d": "M9 11l4 0", "key": "svg-2" }]]);

export { IconLicense as default };
//# sourceMappingURL=IconLicense.mjs.map
